import testimonial1 from '../assets/testimonial1.jpeg';
import testimonial2 from '../assets/testimonial2.jpeg';
import testimonial3 from '../assets/testimonial3.jpeg';
import testimonial4 from '../assets/testimonial4.jpeg';
import testimonial5 from '../assets/testimonial5.jpeg';
import testimonial6 from '../assets/testimonial6.jpeg';
import testimonial7 from '../assets/testimonial7.jpeg';

const fakeJSON = () => {
  return [
    {
      image: testimonial1,
      review: `I lost 17kg so far. I weighed 87kg when I joined Fitness Space. I decided to take my fitness back after I lost consciousness when taking a bath. Fitness Space helped to get my life back by totally embracing healthier lifestyle changes.`,
      name: `Abimbola, Lagos`,
    },
    {
      image: testimonial2,
      review: `I have lost about 28kg. I used to workout every day. As I neared my goal, I reduced it to 6 days, giving myself one day of rest. Now, I do 3 to 4 days a week. These exercises have helped my body build strength, sped up metabolism and improved my skin's health.`,
      name: `Bettie, Lagos`,
    },
    {
      image: testimonial3,
      review: `I started my weight loss and fitness journey with Fitness Space in January 2023 and all I could say is that it has been an amazing journey. I didn’t only get my body back, I got my life back, I got my soul back. Fitness Space has made it easy for me to embrace healthier lifestyle. I will always be part of the family.`,
      name: `Abims, Lagos`,
    },
    {
      image: testimonial4,
      review: `I decided to make a better and healthier lifestyle change in October 2022 and that was when I stumbled on Fitness Space through their Instagram account. I tried other weight loss products and none of them worked. Daily baby steps I took with the coaches led to giant results in few months.`,
      name: `Olayinka, Lagos`,
    },
    {
      image: testimonial5,
      review: `I joined during last year’s No Soda Challenge and my life has never been the same again. I lost 5kg at the end of the first month and have lost 20kg so far. I happy I found you guys. `,
      name: `Rosemary, Port Harcourt`,
    },
    {
      image: testimonial6,
      review: `I had plans to lose 5kg but eventually lost 3kg. I indulged a lot because of stress eating and period cravings. I plan to do better next month.`,
      name: `Marvis, Lagos.`,
    },
    {
      image: testimonial7,
      review: `There was this jeans I couldn’t wear a month ago without being unable to breath. Today, I wore it and without my belly tucked in. Keep going, shredders. We are doing well. I have paid for 4 months straight.`,
      name: `Nnenna, UK`,
    },
  ];
};

export default fakeJSON;
